import { Button, ButtonSizes, ButtonVariants } from '@triumph/design-system';
import { ProgressSpinner } from 'primereact/progressspinner';

import { useDeepLinkStatus } from '@/components/hooks/useDeepLinkStatus';
import {
    deepLinkMissingCopy,
    deepLinkPendingCopy,
} from '@/components/shared/constants/deepLinkTargets';

import { BannerWrapper } from './DeepLinkBanner.StyledComponents';

const SPINNER_STYLE = { width: '1.25em', height: '1.25em', margin: 0 };
const SPINNER_STROKE_WIDTH = '4';

interface DeepLinkBannerProps {
    isPageReady: boolean;
}

export const DeepLinkBanner = ({ isPageReady }: DeepLinkBannerProps) => {
    const { pendingLabel, missingLabel, dismiss } = useDeepLinkStatus(isPageReady);

    const label = missingLabel ?? pendingLabel;
    if (!label) return null;

    const isMissing = Boolean(missingLabel);
    const message = isMissing ? deepLinkMissingCopy(label) : deepLinkPendingCopy(label);

    return (
        <BannerWrapper
            variant={isMissing ? 'missing' : 'pending'}
            role={isMissing ? 'alert' : 'status'}
            data-testid="deep-link-banner"
        >
            {isMissing ? null : (
                <ProgressSpinner style={SPINNER_STYLE} strokeWidth={SPINNER_STROKE_WIDTH} />
            )}
            <span>{message}</span>
            <Button
                variant={ButtonVariants.secondary}
                size={ButtonSizes.small}
                onClick={dismiss}
                data-testid="deep-link-banner-dismiss"
            >
                DISMISS
            </Button>
        </BannerWrapper>
    );
};
